var executeScripts = require('./dist');

module.exports = executeScripts.default;
